import {
  GetSnapshot,
  PostSnapshotByPeriodo,
  PutSnapshotEvaluacion,
  DeleteSnapshotEvaluacion,
  GetResumen,
  GetResumenAsesor,
  PutCambiarVendedor
} from "../../../reducers/comisionMembresia";
import * as actions from "../../../actions/comisionMembresia";
import { Preview } from "../../../../types/IAction";

export interface ReporteAsesorDispatcher {
  clearSnapshot: () => Promise<Preview<void>>;
  getSnapshotByFolioFactura: (
    folioFactura: string,
    page: number,
    size: number
  ) => Promise<Preview<GetSnapshot>>;
  getSnapshotByPeriodo: (
    periodo: string,
    idClub?: number,
    tipoOperacion?: string,
    conCambios?: boolean,
    evaluadorModifico?: boolean,
    sinCumplimiento?: boolean,
    page?: number,
    size?: number
  ) => Promise<Preview<GetSnapshot>>;
  getSnapshotByAsesor: (
    periodo: string,
    idVendedor: number,
    page: number,
    size: number,
    tipoOperacion?: string
  ) => Promise<Preview<GetSnapshot>>;
  postSnapshotByPeriodo: (
    periodo: string
  ) => Promise<Preview<PostSnapshotByPeriodo>>;
  putSnapshotEvaluacion: (
    idCotizacionItem: number,
    actualizacion: any
  ) => Promise<Preview<PutSnapshotEvaluacion>>;
  deleteSnapshotEvaluacion: (
    idCotizacionItem: number
  ) => Promise<Preview<DeleteSnapshotEvaluacion>>;
  clearResumen: () => Promise<Preview<void>>;
  getResumenByPeriodo: (periodo: string) => Promise<Preview<GetResumen>>;
  getResumenByPeriodoAndIdClub: (
    periodo: string,
    idClub: number
  ) => Promise<Preview<GetResumen>>;
  putCambiarVendedor: (
    idCotizacionItem: number,
    request: any
  ) => Promise<Preview<PutCambiarVendedor>>;
  getResumenByAsesor: (
    periodo: string,
    idVendedor?: number
  ) => Promise<Preview<GetResumenAsesor>>;
}

export const reporteAsesorDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ReporteAsesorDispatcher = dispatch => ({
  clearSnapshot: () => {
    return dispatch(actions.clearSnapshot());
  },
  getSnapshotByFolioFactura: (
    folioFactura: string,
    page: number,
    size: number
  ) => {
    return dispatch(
      actions.getSnapshotByFolioFactura(folioFactura, page, size)
    );
  },
  getSnapshotByPeriodo: (
    periodo: string,
    idClub?: number,
    tipoOperacion?: string,
    conCambios?: boolean,
    evaluadorModifico?: boolean,
    sinCumplimiento?: boolean,
    page?: number,
    size?: number
  ) => {
    return dispatch(
      actions.getSnapshotByPeriodo(
        periodo,
        idClub,
        tipoOperacion,
        conCambios,
        evaluadorModifico,
        sinCumplimiento,
        page,
        size
      )
    );
  },
  getSnapshotByAsesor: (
    periodo: string,
    idVendedor: number,
    page: number,
    size: number,
    tipoOperacion?: string
  ) => {
    return dispatch(
      actions.getSnapshotByAsesor(
        periodo,
        idVendedor,
        page,
        size,
        tipoOperacion
      )
    );
  },
  postSnapshotByPeriodo: (periodo: string) => {
    return dispatch(actions.postSnapshotByPeriodo(periodo));
  },
  putSnapshotEvaluacion: (idCotizacionItem: number, actualizacion: any) => {
    return dispatch(
      actions.putSnapshotEvaluacion(idCotizacionItem, actualizacion)
    );
  },
  deleteSnapshotEvaluacion: (idCotizacionItem: number) => {
    return dispatch(actions.deleteSnapshotEvaluacion(idCotizacionItem));
  },
  clearResumen: () => {
    return dispatch(actions.clearResumen());
  },
  getResumenByPeriodo: (periodo: string) => {
    return dispatch(actions.getResumenByPeriodo(periodo));
  },
  getResumenByPeriodoAndIdClub: (periodo: string, idClub: number) => {
    return dispatch(actions.getResumenByPeriodoAndIdClub(periodo, idClub));
  },
  putCambiarVendedor: (idCotizacionItem: number, request: any) => {
    return dispatch(actions.putCambiarVendedor(idCotizacionItem, request));
  },
  getResumenByAsesor: (periodo: string, idVendedor?: number) => {
    return dispatch(actions.getResumenByAsesor(periodo, idVendedor));
  }
});
